import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import map from 'lodash/map'
import Layout from '../Layout'
import SEO from '../components/SEO'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { getComponentForType } from '../../utils/siteHelper'

const PageTemplate = ({ data, pageContext }) => {
  const {
    title,
    metaTitle,
    slug,
    pageModules,
    enableLightTheme,
  } = data.contentfulPage
  const postNode = data.contentfulPage
  const hasCustomAnimation = pageContext.hasCustomAnimation

  /*
    Iterate over the list of configured page modules & find the correct React component
  */
  const pageComponents = map(pageModules, ({ id, ...module }) => {
    const Component = getComponentForType(get(module, '__typename'))
    return <Component key={id} {...module} />
  })

  return (
    <Layout lighttheme={enableLightTheme} hasCustomAnimation={hasCustomAnimation} isLegalPage={slug === 'legal'}>
      <SEO pagePath={slug} postNode={postNode} pageSEO />

      <main className="main-content">
        <h1 className="sr-only">{metaTitle || title}</h1>
        {pageComponents}
      </main>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    contentfulPage(slug: { eq: $slug }) {
      title
      metaTitle
      slug
      keywords
      ogDescription
      metaDescription {
        internal {
          content
        }
      }
      enableLightTheme
      pageModules {
        ...PageTitleFragment
        ...PageContentFragment
        ...FAQFragment
        ...TabNavigationFragment
        ...TabsContainerFragment
        ...HeroBannerFragment
        ...BasicCarouselFragment
        ...BasicCarouselWithThumbsFragment
        ...ArticleCarouselFragment
        ...TextWithBackgroundFragment
        ...TextImageGridFragment
        ...TextWithFeatureImageFragment
        ...ContactFormFragment
        ...ArticleGridContainerFragment
        ...PressCentreFragment
        ...ProductCarouselFragment
        ...ProductGridFragment
        ...TextImageWithCTAFragment
        ...AnimationContainerFragment
        ...SignUpBannerFragment
      }
    }
  }
`

PageTemplate.propTypes = {
  data: PropTypes.shape({
    contentfulPage: PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string,
      keywords: PropTypes.string,
    }),
  }).isRequired,
  pageContext: PropTypes.shape({
    hasCustomAnimation: PropTypes.bool,
  }).isRequired,
}

export default PageTemplate
